import { DefaultTheme } from 'styled-components'
import { THEME_BASED_COHORT } from '~/shared/contexts/constants'
import { BIOLOGY_THEME } from '~/shared/styles/theme'

export const getTheme = (cohort: string): DefaultTheme => {
  return THEME_BASED_COHORT[cohort] ?? BIOLOGY_THEME
}
